let data = '';
let currentLanguage = 'de'

function setLanguage(){

}

export function setData(json) {
    data = json;
}

export var store = {
    state: {
        shops: data,
        categories: [],

    },
}